export const API = {
  // DASHBOARD
  dashboard: {
    // V1
    FETCH__ALL: () => '/api/v2/b2b/dashboard',
  },
};
